/**
 * Reusable logo component
 */
import { useTranslations } from "next-intl";

export const Logo = (props: PropsWithClassName<{}>) => {
  const t = useTranslations("Global");

  return (
    <img
      src="/global_assets/pirate-nation-logo.compressed.png"
      alt={t("alt_logo")}
      {...props}
    />
  );
};
